<template>
  <Container padding-top>
    <SitePageTitle :title="title" />
    <SitePageList v-if="items.length" :items="items" />
  </Container>
</template>
<script setup lang="ts">
// A Storyblok page without blocks (Over ons, Impressie) lists the pages in its folder instead of staying empty
const props = defineProps<{ story: any }>()

const title = computed(() => props.story?.name ?? '')
const folder = String(props.story?.full_slug ?? '').replace(/\/?$/, '/')

const data = await useHrStoryblok('cdn/stories', { starts_with: folder, per_page: 100, sort_by: 'position:asc' })

// Albums are named like "2025 - Effe Wachten"
const album = (name: string) => /^(\d{4})\s*-\s*(.+)$/.exec(name.replace(/\.\.\./g, '…'))

const heroImage = (content: any) => content?.blocks
  ?.find((block: any) => block.component === 'SbHero')
  ?.background?.find((block: any) => block.component === 'SbImage')
  ?.image?.filename

const items = computed(() => {
  const children = (((data as any)?.stories ?? []) as Array<any>)
    .filter(story => story.full_slug !== folder && !story.full_slug.slice(folder.length).replace(/\/$/, '').includes('/'))
    .map(story => {
      const name = story.content?.title || story.name
      const match = album(name)
      return {
        to: `/${story.full_slug.replace(/\/$/, '')}`,
        title: match ? match[2] : name,
        meta: match ? `Seizoen ${match[1]}` : undefined,
        year: match ? Number(match[1]) : 0,
        image: story.content?.items?.[0]?.filename || heroImage(story.content) || story.content?.image?.filename,
        text: story.content?.items?.length ? `${story.content.items.length} foto’s` : story.content?.description
      }
    })
  // Newest season first; pages without a season keep their Storyblok order after the albums
  return children.sort((a, b) => b.year - a.year)
})

useHead({ title })
</script>
